// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"Privacy_privacyPolicy__1SzbT","title":"Privacy_title__GnVxq","section":"Privacy_section__sJL1+","list":"Privacy_list__L7MXK"};